var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 40,
    rx: 19,
    fill: "#EAEFF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 29C27 26.2386 23.4183 24 19 24C14.5817 24 11 26.2386 11 29M19 21C16.2386 21 14 18.7614 14 16C14 13.2386 16.2386 11 19 11C21.7614 11 24 13.2386 24 16C24 18.7614 21.7614 21 19 21Z",
    stroke: "#30537E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.cc5df925e41429e3f868e8baacc40bf8.svg";
export { ForwardRef as ReactComponent };